import { ImportedListing } from '../_types/imported-listing'

const defaultImportedListing: ImportedListing = {
  id: '',
  quickPassUserId: '',
  sourceUrl: '',
  sourceSite: 'unknown',
  title: '',
  description: '',
  imageUrls: [],
  priceMonthly: null,
  priceCurrency: 'CAD',
  bedrooms: null,
  bathrooms: null,
  propertyType: null,
  city: '',
  fullAddress: null,
  isAvailable: null,
  availableDate: null,
  lastScrapedAt: 0,
  scrapeStatus: 'failed',
  scrapeNotes: '',
  priceHistory: [],
  availabilityHistory: [],
  createdAt: 0,
  updatedAt: 0,
}

export { defaultImportedListing }
